"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ledger/transaction-error-code.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fledger%2Ftransaction-error-code.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.transactionErrorCodeToJSON = exports.transactionErrorCodeFromJSON = exports.TransactionErrorCode = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.transaction.proto';
var TransactionErrorCode;
(function (TransactionErrorCode) {
    TransactionErrorCode["INVALID_ERROR_CODE"] = "INVALID_ERROR_CODE";
    TransactionErrorCode["INVALID_CURRENCY"] = "INVALID_CURRENCY";
    TransactionErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    TransactionErrorCode["PAYMENT_NOT_FOUND"] = "PAYMENT_NOT_FOUND";
    TransactionErrorCode["ISSUER_ERROR"] = "ISSUER_ERROR";
    TransactionErrorCode["PICK_UP"] = "PICK_UP";
    TransactionErrorCode["DO_NOT_HONOR"] = "DO_NOT_HONOR";
    TransactionErrorCode["ERROR"] = "ERROR";
    TransactionErrorCode["INVALID_PAN"] = "INVALID_PAN";
    TransactionErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    TransactionErrorCode["CARD_LOST"] = "CARD_LOST";
    TransactionErrorCode["CARD_STOLEN"] = "CARD_STOLEN";
    TransactionErrorCode["CARD_EXPIRED"] = "CARD_EXPIRED";
    TransactionErrorCode["INVALID_PIN"] = "INVALID_PIN";
    TransactionErrorCode["NOT_PERMITTED"] = "NOT_PERMITTED";
    TransactionErrorCode["FRAUD"] = "FRAUD";
    TransactionErrorCode["EXCEEDS_AMOUNT_LIMIT"] = "EXCEEDS_AMOUNT_LIMIT";
    TransactionErrorCode["EXCEEDS_COUNT_LIMIT"] = "EXCEEDS_COUNT_LIMIT";
    TransactionErrorCode["INVALID_PIN_EXCEEDED"] = "INVALID_PIN_EXCEEDED";
    TransactionErrorCode["INVALID_SECURITY_CODE"] = "INVALID_SECURITY_CODE";
    TransactionErrorCode["EXCEEDS_ACCOUNT_LIMIT"] = "EXCEEDS_ACCOUNT_LIMIT";
    TransactionErrorCode["INVALID_EXPIRATION"] = "INVALID_EXPIRATION";
    TransactionErrorCode["INVALID_ZIP"] = "INVALID_ZIP";
    TransactionErrorCode["RATE_LIMIT_EXCEEDED"] = "RATE_LIMIT_EXCEEDED";
    TransactionErrorCode["CARD_INACTIVE"] = "CARD_INACTIVE";
    TransactionErrorCode["ATM_ACCESS_DISABLED"] = "ATM_ACCESS_DISABLED";
    TransactionErrorCode["CARD_LOCKED"] = "CARD_LOCKED";
    TransactionErrorCode["WALLET_INACTIVE"] = "WALLET_INACTIVE";
    TransactionErrorCode["ACCOUNT_INACTIVE"] = "ACCOUNT_INACTIVE";
    TransactionErrorCode["BARCODE_EXPIRED"] = "BARCODE_EXPIRED";
    TransactionErrorCode["THREE_D_SECURE_FAILED"] = "THREE_D_SECURE_FAILED";
    TransactionErrorCode["CHECK_DEPOSIT_REJECTED"] = "CHECK_DEPOSIT_REJECTED";
    TransactionErrorCode["MERCHANT_BLOCKED"] = "MERCHANT_BLOCKED";
    TransactionErrorCode["AUTHENTICATION_REQUIRED"] = "AUTHENTICATION_REQUIRED";
    TransactionErrorCode["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
    TransactionErrorCode["FOREIGN_BLOCKED"] = "FOREIGN_BLOCKED";
    TransactionErrorCode["MISSING_IP"] = "MISSING_IP";
    TransactionErrorCode["CARD_ERRORED"] = "CARD_ERRORED";
    TransactionErrorCode["CARD_PAYOUTS_DISABLED"] = "CARD_PAYOUTS_DISABLED";
    TransactionErrorCode["CHECK_CANNOT_READ_CHECK_IMAGE"] = "CHECK_CANNOT_READ_CHECK_IMAGE";
    TransactionErrorCode["CHECK_ENDORSEMENT_MISSING"] = "CHECK_ENDORSEMENT_MISSING";
    TransactionErrorCode["CHECK_DUPLICATE_FRONT_IMAGE_DETECTED"] = "CHECK_DUPLICATE_FRONT_IMAGE_DETECTED";
    TransactionErrorCode["CHECK_AMOUNT_MISMATCH"] = "CHECK_AMOUNT_MISMATCH";
    TransactionErrorCode["CHECK_SETTLEMENT_VERIFICATION_FAILED"] = "CHECK_SETTLEMENT_VERIFICATION_FAILED";
    TransactionErrorCode["CARD_CANCELED"] = "CARD_CANCELED";
    TransactionErrorCode["SMS_CHALLENGE_REQUIRED"] = "SMS_CHALLENGE_REQUIRED";
    TransactionErrorCode["PUSH_FUNDING_REVERSED"] = "PUSH_FUNDING_REVERSED";
    TransactionErrorCode["FAILURE_OTHER"] = "FAILURE_OTHER";
    TransactionErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(TransactionErrorCode || (exports.TransactionErrorCode = TransactionErrorCode = {}));
function transactionErrorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ERROR_CODE':
            return TransactionErrorCode.INVALID_ERROR_CODE;
        case 1:
        case 'INVALID_CURRENCY':
            return TransactionErrorCode.INVALID_CURRENCY;
        case 2:
        case 'INSUFFICIENT_FUNDS':
            return TransactionErrorCode.INSUFFICIENT_FUNDS;
        case 3:
        case 'PAYMENT_NOT_FOUND':
            return TransactionErrorCode.PAYMENT_NOT_FOUND;
        case 4:
        case 'ISSUER_ERROR':
            return TransactionErrorCode.ISSUER_ERROR;
        case 5:
        case 'PICK_UP':
            return TransactionErrorCode.PICK_UP;
        case 6:
        case 'DO_NOT_HONOR':
            return TransactionErrorCode.DO_NOT_HONOR;
        case 7:
        case 'ERROR':
            return TransactionErrorCode.ERROR;
        case 8:
        case 'INVALID_PAN':
            return TransactionErrorCode.INVALID_PAN;
        case 9:
        case 'FORMAT_ERROR':
            return TransactionErrorCode.FORMAT_ERROR;
        case 10:
        case 'CARD_LOST':
            return TransactionErrorCode.CARD_LOST;
        case 11:
        case 'CARD_STOLEN':
            return TransactionErrorCode.CARD_STOLEN;
        case 12:
        case 'CARD_EXPIRED':
            return TransactionErrorCode.CARD_EXPIRED;
        case 13:
        case 'INVALID_PIN':
            return TransactionErrorCode.INVALID_PIN;
        case 14:
        case 'NOT_PERMITTED':
            return TransactionErrorCode.NOT_PERMITTED;
        case 15:
        case 'FRAUD':
            return TransactionErrorCode.FRAUD;
        case 16:
        case 'EXCEEDS_AMOUNT_LIMIT':
            return TransactionErrorCode.EXCEEDS_AMOUNT_LIMIT;
        case 17:
        case 'EXCEEDS_COUNT_LIMIT':
            return TransactionErrorCode.EXCEEDS_COUNT_LIMIT;
        case 18:
        case 'INVALID_PIN_EXCEEDED':
            return TransactionErrorCode.INVALID_PIN_EXCEEDED;
        case 19:
        case 'INVALID_SECURITY_CODE':
            return TransactionErrorCode.INVALID_SECURITY_CODE;
        case 20:
        case 'EXCEEDS_ACCOUNT_LIMIT':
            return TransactionErrorCode.EXCEEDS_ACCOUNT_LIMIT;
        case 21:
        case 'INVALID_EXPIRATION':
            return TransactionErrorCode.INVALID_EXPIRATION;
        case 22:
        case 'INVALID_ZIP':
            return TransactionErrorCode.INVALID_ZIP;
        case 23:
        case 'RATE_LIMIT_EXCEEDED':
            return TransactionErrorCode.RATE_LIMIT_EXCEEDED;
        case 24:
        case 'CARD_INACTIVE':
            return TransactionErrorCode.CARD_INACTIVE;
        case 25:
        case 'ATM_ACCESS_DISABLED':
            return TransactionErrorCode.ATM_ACCESS_DISABLED;
        case 26:
        case 'CARD_LOCKED':
            return TransactionErrorCode.CARD_LOCKED;
        case 27:
        case 'WALLET_INACTIVE':
            return TransactionErrorCode.WALLET_INACTIVE;
        case 28:
        case 'ACCOUNT_INACTIVE':
            return TransactionErrorCode.ACCOUNT_INACTIVE;
        case 29:
        case 'BARCODE_EXPIRED':
            return TransactionErrorCode.BARCODE_EXPIRED;
        case 30:
        case 'THREE_D_SECURE_FAILED':
            return TransactionErrorCode.THREE_D_SECURE_FAILED;
        case 31:
        case 'CHECK_DEPOSIT_REJECTED':
            return TransactionErrorCode.CHECK_DEPOSIT_REJECTED;
        case 32:
        case 'MERCHANT_BLOCKED':
            return TransactionErrorCode.MERCHANT_BLOCKED;
        case 33:
        case 'AUTHENTICATION_REQUIRED':
            return TransactionErrorCode.AUTHENTICATION_REQUIRED;
        case 34:
        case 'AUTHENTICATION_FAILED':
            return TransactionErrorCode.AUTHENTICATION_FAILED;
        case 35:
        case 'FOREIGN_BLOCKED':
            return TransactionErrorCode.FOREIGN_BLOCKED;
        case 36:
        case 'MISSING_IP':
            return TransactionErrorCode.MISSING_IP;
        case 37:
        case 'CARD_ERRORED':
            return TransactionErrorCode.CARD_ERRORED;
        case 38:
        case 'CARD_PAYOUTS_DISABLED':
            return TransactionErrorCode.CARD_PAYOUTS_DISABLED;
        case 39:
        case 'CHECK_CANNOT_READ_CHECK_IMAGE':
            return TransactionErrorCode.CHECK_CANNOT_READ_CHECK_IMAGE;
        case 40:
        case 'CHECK_ENDORSEMENT_MISSING':
            return TransactionErrorCode.CHECK_ENDORSEMENT_MISSING;
        case 41:
        case 'CHECK_DUPLICATE_FRONT_IMAGE_DETECTED':
            return TransactionErrorCode.CHECK_DUPLICATE_FRONT_IMAGE_DETECTED;
        case 42:
        case 'CHECK_AMOUNT_MISMATCH':
            return TransactionErrorCode.CHECK_AMOUNT_MISMATCH;
        case 43:
        case 'CHECK_SETTLEMENT_VERIFICATION_FAILED':
            return TransactionErrorCode.CHECK_SETTLEMENT_VERIFICATION_FAILED;
        case 44:
        case 'CARD_CANCELED':
            return TransactionErrorCode.CARD_CANCELED;
        case 45:
        case 'SMS_CHALLENGE_REQUIRED':
            return TransactionErrorCode.SMS_CHALLENGE_REQUIRED;
        case 46:
        case 'PUSH_FUNDING_REVERSED':
            return TransactionErrorCode.PUSH_FUNDING_REVERSED;
        case 9999:
        case 'FAILURE_OTHER':
            return TransactionErrorCode.FAILURE_OTHER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return TransactionErrorCode.UNRECOGNIZED;
    }
}
exports.transactionErrorCodeFromJSON = transactionErrorCodeFromJSON;
function transactionErrorCodeToJSON(object) {
    switch (object) {
        case TransactionErrorCode.INVALID_ERROR_CODE:
            return 'INVALID_ERROR_CODE';
        case TransactionErrorCode.INVALID_CURRENCY:
            return 'INVALID_CURRENCY';
        case TransactionErrorCode.INSUFFICIENT_FUNDS:
            return 'INSUFFICIENT_FUNDS';
        case TransactionErrorCode.PAYMENT_NOT_FOUND:
            return 'PAYMENT_NOT_FOUND';
        case TransactionErrorCode.ISSUER_ERROR:
            return 'ISSUER_ERROR';
        case TransactionErrorCode.PICK_UP:
            return 'PICK_UP';
        case TransactionErrorCode.DO_NOT_HONOR:
            return 'DO_NOT_HONOR';
        case TransactionErrorCode.ERROR:
            return 'ERROR';
        case TransactionErrorCode.INVALID_PAN:
            return 'INVALID_PAN';
        case TransactionErrorCode.FORMAT_ERROR:
            return 'FORMAT_ERROR';
        case TransactionErrorCode.CARD_LOST:
            return 'CARD_LOST';
        case TransactionErrorCode.CARD_STOLEN:
            return 'CARD_STOLEN';
        case TransactionErrorCode.CARD_EXPIRED:
            return 'CARD_EXPIRED';
        case TransactionErrorCode.INVALID_PIN:
            return 'INVALID_PIN';
        case TransactionErrorCode.NOT_PERMITTED:
            return 'NOT_PERMITTED';
        case TransactionErrorCode.FRAUD:
            return 'FRAUD';
        case TransactionErrorCode.EXCEEDS_AMOUNT_LIMIT:
            return 'EXCEEDS_AMOUNT_LIMIT';
        case TransactionErrorCode.EXCEEDS_COUNT_LIMIT:
            return 'EXCEEDS_COUNT_LIMIT';
        case TransactionErrorCode.INVALID_PIN_EXCEEDED:
            return 'INVALID_PIN_EXCEEDED';
        case TransactionErrorCode.INVALID_SECURITY_CODE:
            return 'INVALID_SECURITY_CODE';
        case TransactionErrorCode.EXCEEDS_ACCOUNT_LIMIT:
            return 'EXCEEDS_ACCOUNT_LIMIT';
        case TransactionErrorCode.INVALID_EXPIRATION:
            return 'INVALID_EXPIRATION';
        case TransactionErrorCode.INVALID_ZIP:
            return 'INVALID_ZIP';
        case TransactionErrorCode.RATE_LIMIT_EXCEEDED:
            return 'RATE_LIMIT_EXCEEDED';
        case TransactionErrorCode.CARD_INACTIVE:
            return 'CARD_INACTIVE';
        case TransactionErrorCode.ATM_ACCESS_DISABLED:
            return 'ATM_ACCESS_DISABLED';
        case TransactionErrorCode.CARD_LOCKED:
            return 'CARD_LOCKED';
        case TransactionErrorCode.WALLET_INACTIVE:
            return 'WALLET_INACTIVE';
        case TransactionErrorCode.ACCOUNT_INACTIVE:
            return 'ACCOUNT_INACTIVE';
        case TransactionErrorCode.BARCODE_EXPIRED:
            return 'BARCODE_EXPIRED';
        case TransactionErrorCode.THREE_D_SECURE_FAILED:
            return 'THREE_D_SECURE_FAILED';
        case TransactionErrorCode.CHECK_DEPOSIT_REJECTED:
            return 'CHECK_DEPOSIT_REJECTED';
        case TransactionErrorCode.MERCHANT_BLOCKED:
            return 'MERCHANT_BLOCKED';
        case TransactionErrorCode.AUTHENTICATION_REQUIRED:
            return 'AUTHENTICATION_REQUIRED';
        case TransactionErrorCode.AUTHENTICATION_FAILED:
            return 'AUTHENTICATION_FAILED';
        case TransactionErrorCode.FOREIGN_BLOCKED:
            return 'FOREIGN_BLOCKED';
        case TransactionErrorCode.MISSING_IP:
            return 'MISSING_IP';
        case TransactionErrorCode.CARD_ERRORED:
            return 'CARD_ERRORED';
        case TransactionErrorCode.CARD_PAYOUTS_DISABLED:
            return 'CARD_PAYOUTS_DISABLED';
        case TransactionErrorCode.CHECK_CANNOT_READ_CHECK_IMAGE:
            return 'CHECK_CANNOT_READ_CHECK_IMAGE';
        case TransactionErrorCode.CHECK_ENDORSEMENT_MISSING:
            return 'CHECK_ENDORSEMENT_MISSING';
        case TransactionErrorCode.CHECK_DUPLICATE_FRONT_IMAGE_DETECTED:
            return 'CHECK_DUPLICATE_FRONT_IMAGE_DETECTED';
        case TransactionErrorCode.CHECK_AMOUNT_MISMATCH:
            return 'CHECK_AMOUNT_MISMATCH';
        case TransactionErrorCode.CHECK_SETTLEMENT_VERIFICATION_FAILED:
            return 'CHECK_SETTLEMENT_VERIFICATION_FAILED';
        case TransactionErrorCode.CARD_CANCELED:
            return 'CARD_CANCELED';
        case TransactionErrorCode.SMS_CHALLENGE_REQUIRED:
            return 'SMS_CHALLENGE_REQUIRED';
        case TransactionErrorCode.PUSH_FUNDING_REVERSED:
            return 'PUSH_FUNDING_REVERSED';
        case TransactionErrorCode.FAILURE_OTHER:
            return 'FAILURE_OTHER';
        case TransactionErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.transactionErrorCodeToJSON = transactionErrorCodeToJSON;
//# sourceMappingURL=transaction-error-code.js.map